import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AppRoutingService } from '@ui-components/services';
import { CookieService } from 'ngx-cookie-service';
import { Observable, map } from 'rxjs';
import { AdminSessionService } from './services/admin-session.service';


export const AuthGuard: CanActivateFn = ():
Observable<boolean | UrlTree>
| boolean => {

  const cookie_service = inject(CookieService);
  const app_routing_service = inject(AppRoutingService);
  const admin_session_service = inject(AdminSessionService);
  const router = inject(Router);

  if (!cookie_service.get('access_token')) {
    app_routing_service.gotToAccess('login');
    return false;
  }

  return admin_session_service.access().pipe(
    map((access) => {
      if (access === 'admin') {
        return true;
      }
      if (access === 'forbidden') {
        return router.parseUrl('/no-access');
      }
      app_routing_service.gotToAccess('login');
      return false;
    })
  );
}
